import { AddressType } from '@onrunning/backstage-models';
export class AccountAddress {
  public id?: string;
  public addressType: AddressType;
  public street: string;
  public city: string;
  public country: string;
  public state?: string;
  public zipCode: string;
  public streetDescription?: string;
}
